module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/tools/messages/messages.component.css
// module id = ./src/app/components/tools/messages/messages.component.css
// module chunks = main